import { createAction, props } from '@ngrx/store';
import { IUser } from '../users.models';
import { IUserState } from './users.state';
import { IProcessPartnerAssignmentRequest } from '../../process-partners/process-partners.models';

export const loadUsers = createAction('[Users] Load Users');
export const loadUsersSuccess = createAction(
  '[Users] Load Users Success',
  props<IUserState>()
);
export const loadUsersFailure = createAction(
  '[Users] Load Users Failure',
  props<{
    error: unknown;
    loading: boolean;
  }>()
);
export const loadUserById = createAction(
  '[Users] Load User By ID',
  props<{ id: number }>()
);
export const loadUserByIdSuccess = createAction(
  '[Users] Load User By ID Success',
  props<{ user: IUser }>()
);
export const loadUserByIdFailure = createAction(
  '[Users] Load User By ID Failure',
  props<{ error: unknown }>()
);

export const createUser = createAction(
  '[Users] Create User',
  props<{ user: Partial<IUser> }>()
);
export const createUserSuccess = createAction(
  '[Users] Create User Success',
  props<{ user: IUser }>()
);
export const createUserFailure = createAction(
  '[Users] Create User Failure',
  props<{ error: unknown }>()
);

export const updateUser = createAction(
  '[Users] Update User',
  props<{ userId: number; countryId: number; changes: Partial<IUser> }>()
);
export const updateUserSuccess = createAction(
  '[Users] Update User Success',
  props<{ user: IUser }>()
);
export const updateUserFailure = createAction(
  '[Users] Update User Failure',
  props<{ error: unknown }>()
);

export const assignProcessPartners = createAction(
  '[Users] Assign Process Partners',
  props<{
    userId: number;
    countryId: number;
    processPartners: IProcessPartnerAssignmentRequest[];
  }>()
);

export const assignProcessPartnersSuccess = createAction(
  '[Users] Assign Process Partners Success',
  props<{ user: IUser }>()
);

export const assignProcessPartnersFailure = createAction(
  '[Users] Assign Process Partners Failure',
  props<{ error: unknown }>()
);

export const assignSurveyPoints = createAction(
  '[Users] Assign Survey Points',
  props<{ userId: number; countryId: number; surveyPointIds: number[] }>()
);

export const assignSurveyPointsSuccess = createAction(
  '[Users] Assign Survey Points Success',
  props<{ user: IUser }>()
);

export const assignSurveyPointsFailure = createAction(
  '[Users] Assign Survey Points Failure',
  props<{ error: unknown }>()
);
